// Matches hrefs that leave our origin: any scheme, protocol-relative, or backslash-smuggled.
export const EXTERNAL_HREF_PATTERN = /^(?:[a-z][a-z\d+.-]*:|\/\/|\/\\)/i;

export const isInternalHref = (href: string) => {
  const normalizedHref = href.trimStart();
  return (
    !normalizedHref.startsWith("#") &&
    !EXTERNAL_HREF_PATTERN.test(normalizedHref)
  );
};
